import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=223ec2f2&scoped=true&"
import script from "./PaymentDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=223ec2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ec2f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VFadeTransition})
